export default __webpack_public_path__ + "static/media/comp.b4bec3a3.svg";